import { call } from 'redux-saga/effects'

import type { SocketActions } from '../actions'
import { socket } from '../socket'
import { leaveUserRoom } from './user'
import { leaveWorkspace } from './workspace'

export function* unsubscribe({
  payload: { id },
}: ReturnType<typeof SocketActions.unsubscribe>) {
  yield call(console.info, 'socket unsubscribe')

  socket.off(`sync:${id}`)
  socket.off(`delete:${id}`)
  socket.off(`refresh:${id}`)
  socket.off(`comments:${id}`)
  socket.off(`comment-read:${id}`)
  socket.off('library')

  leaveWorkspace()
  leaveUserRoom()
}
